import React, {useState} from "react";
// import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar";
import Cookie from "./Cookies";
import CustomAutoComplete from "./AutoCompleteCustom";
import Button from "./Button";
import ConnectionFinder from "../api/ConnectionFinder";
import Loading from "./Loading";
import NavButton from "./NavButton";

import FibercopResult from "./TotalResearch/FibercopResult";
import OpenfiberResult from "./TotalResearch/OpenfiberResult";
import UnidataResult from "./TotalResearch/UnidataResult";

// import ForwardIcon from './img/forward.png';

import "./styles/Fibre.css"
import "./styles/Total.css"


const setConnectionText = (is_connected) => {
    return is_connected  ? <span style={{color: 'white', backgroundColor: '#2ecc71', padding: '5px', paddingInline: '6px', borderRadius: '10px', fontWeight: 'bold', fontSize: '1.1rem'}}>Connesso</span> : <span style={{color: 'white', backgroundColor: '#d2042d', padding: '5px', paddingInline: '6px',borderRadius: '10px', fontWeight: 'bold', fontSize: '1.1rem'}}>Non connesso</span>;
}

const TotalResearch = () => {
    const [cities, setCities] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [civics, setCivics] = useState([]);

    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [civic, setCivic] = useState("");

    // const [egon, setEgon] = useState("");
    const [results, setResults] = useState(<h1 className="resultPlaceholder">Esegui la ricerca</h1>);

    // const navigate = useNavigate();

    const clearOptionsFor = (labels) => {
        const options = {
            comune: () => { 
                setCities([]) 
                setCity("")
            },
            indirizzo: () => {
                setAddresses([])
                setAddress("")            
            },
            civico: () => {
                setCivics([])
                setCivic("")
            },
        }
    
        labels.forEach(label => {
            options[label]();
        });

    }
    
    const getCities = (city) => {
        if(city.length === 0) clearOptionsFor(['comune', 'indirizzo', 'civico']);
        if(city.length !== 3) return;

        ConnectionFinder.get("/research/total/cities",
            {   
                headers: { "x-access-token": localStorage.getItem('token') },
                params: { name: city } 
            })
        .then((response) => {
            setCities(sortByLength(response.data, 'Denominazione_in_italiano'));
        })
    }

    const getAddresses = (address) => {
        const city = document.getElementById("comune").value;

        if(city.length === 0) return alert("Compila prima il campo comune!");

        if(address.length === 0) clearOptionsFor(['indirizzo', 'civico']);
        if(address.length !== 3) return;

        ConnectionFinder.get("/research/total/addresses",
            {   
                headers: { "x-access-token": localStorage.getItem('token') },
                params: { city, address } 
            })
        .then((response) => {
            setAddresses(response.data);
        })
    }

    const getEgon = (address, addrList) => {
        let egon = "0";
        addrList.forEach(element => {
            if(element.address === address) {
                egon = element.egon
            }
        });
        return egon;
    
    }

    function sortByLength (array, property) {
        return array.sort((x,y) => x[property].length - y[property].length);
    }

    const getCivics = (civic) => {
        const city = document.getElementById("comune").value;
        const address = document.getElementById("indirizzo").value;

        if(address.length === 0) return alert("Compila prima il campo indirizzo!");

        if(civic.length === 0) clearOptionsFor(['civico']);
        if (civic.length !== 1) return;

        ConnectionFinder.get("/research/total/civics",
            {   
                headers: { "x-access-token": localStorage.getItem('token') },
                params: { city, address: getEgon(address, addresses), civic } 
            })
        .then((response) => {
            setCivics(response.data.sort());
        })
    }

    // const specificResearch = (civic) => {
    //     navigate("/research", 
    //         {
    //             replace: true,
    //             state: {
    //                 city: document.getElementById("comune").value,
    //                 address: document.getElementById("indirizzo").value,
    //                 civic,
    //                 egon: getEgon(document.getElementById("indirizzo").value, addresses)
    //             }
    //         }
    //     );
    // }

    const getResults = () => {
        const city = document.getElementById("comune").value;
        const address = document.getElementById("indirizzo").value;
        const civic = document.getElementById("civico").value;

        if(city.length === 0 || address.length === 0) return alert("Compila i campi obbligatori!");

        setResults(<Loading />)

        ConnectionFinder.get("/research/total/results",
            {   
                headers: { "x-access-token": localStorage.getItem('token') },
                params: {city, address, egon: getEgon(address, addresses), civic} 
            })
        .then((response) => {
            const data = response.data;
            setResults(
                <div style={{marginLeft: '10px'}}>
                    <h2 style={{color: '#a6acaf',}}>Fibercop {setConnectionText(data.FC.is_connected)}</h2>
                    {data.FC.is_connected && <FibercopResult data={data} address={address}/>}
                    <h2 style={{color: '#a6acaf'}}>Openfiber {setConnectionText(data.OF.is_connected)}</h2>
                    {data.OF.is_connected && <OpenfiberResult data={data} civic={civic}/>}
                    {(data.OF.is_connected && data.OF.details.records.length > 1) && (
                        <div>
                            <h3 style={{textAlign: 'center'}}>Civici e scale</h3>
                            <ul style={{fontSize: '23px', listStyleType: 'none', paddingLeft: '0', maxHeight: '150px', padding: '10px', overflowY: 'scroll', width: '60%', margin: 'auto'}}>
                                {data.OF.details.records.map((item, index) => (
                                    <li key={index} style={{color: '#a6acaf', width: '95%', display: 'flex', margin: 'auto', marginBottom: '5px', border: '1px solid grey', padding: '2px', paddingInline: '5px'}}>
                                        {`${address} ${item.CIVICO} ${item.SCALA_PALAZZINA}`}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <h2 style={{color: '#a6acaf'}}>Fibreconnect {setConnectionText(data.FibreConnect.is_connected)}</h2>
                    <h2 style={{color: '#a6acaf'}}>Unidata {setConnectionText(data.Unidata.is_connected)}</h2>
                    {data.Unidata.is_connected && <UnidataResult data={data} address={address} />}
                </div> 
            )
        })
    }

        

    return (
        <div style={{background: 'rgba(41,44,59,1)', paddingBottom: '30px',minHeight:'calc(100vh - 30px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', overflow: 'hidden'}}>
        <Navbar />
        <NavButton text="Indietro" to="/home"/>
            <div className="totalResearchContainer">
                <div className="totalResearchForm">
                    <h1 style={{color: '#ff0f64'}}>Ricerca generale</h1>
                    <CustomAutoComplete 
                        suggestions={cities.map((city) => city.Denominazione_in_italiano.toUpperCase())}
                        value={city}
                        setvalue={setCity}
                        onTextChange={(e)=>getCities(e.target.value)}
                        sx={{marginTop: '10px'}}
                        disableClearable
                        label="Comune*"
                        id="comune"
                        className="AutoCompleteFibre" 
                    />
                    <CustomAutoComplete 
                        suggestions={addresses.map((address) => address.address)}
                        value={address}
                        setvalue={setAddress}
                        onTextChange={(e)=>getAddresses(e.target.value)}
                        sx={{marginTop: '10px'}}
                        disableClearable
                        label="Indirizzo*"
                        id="indirizzo"
                        className="AutoCompleteFibre" 
                    />
                    <CustomAutoComplete 
                        suggestions={civics.map((civic) => civic.civic)}
                        value={civic}
                        setvalue={setCivic}
                        onTextChange={(e)=>getCivics(e.target.value)}
                        sx={{marginTop: '10px'}}
                        disableClearable
                        label="Civico"
                        id="civico"
                        className="AutoCompleteFibre" 
                    />
                    <Button name="Cerca" style={{margin: 'auto', marginTop: '20px', width: '95%'}} func={() => getResults()}/>
                </div>
                <div className="totalResearchResults">
                    <h1 className="resultTitle">Risultati</h1>
                    {results}
                </div>
            </div>
        <Cookie />
        </div>
    );
}

export default TotalResearch;